import React, { Component } from "react";
import { Field, change as changeFieldValue, formValueSelector } from "redux-form";
import { PropTypes } from "react/lib/React";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { intlShape } from "react-intl";
import MaskedInput from "./MaskedInput";

class PhoneNumberInput extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            isLegacyNumber: false,
            fieldMask: null,
            showFieldValidationError: false,
        };

        this.phoneFormatRegex = /^$|^\(\d{3}\) \d{3}-\d{4}$/;
        this.emptyMask = "(___) ___-____";
        this.validatePhoneFormat = this.validatePhoneFormat.bind(this);
        this.setMask = this.setMask.bind(this);
        this.onPaste = this.onPaste.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.validatePhoneFormatForReduxForm = this.validatePhoneFormatForReduxForm.bind(this);
        this.isNumberValidForOtherFormats = this.isNumberValidForOtherFormats.bind(this);
    }

    componentWillMount() {
        if (this.props.initialPhoneNumber && !this.validatePhoneFormat(this.props.initialPhoneNumber)) {
            this.setState({ isLegacyNumber: true });
        } else {
            this.setMask();
        }
    }

    componentDidUpdate(prevProps) {
        if (this.state.isLegacyNumber && this.isNumberValidForOtherFormats(this.props.currentPhoneNumber)) {
            this.setState({ isLegacyNumber: false });
            this.setMask();
        }

        if (
            this.props.currentPhoneNumber &&
            this.props.currentPhoneNumber.length <= 10 &&
            this.props.currentPhoneNumber.length > 0 &&
            prevProps.currentPhoneNumber !== this.props.currentPhoneNumber
        ) {
            this.setMask();
            let formatted = this.props.currentPhoneNumber.toString().replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
            this.props.changeFieldValue(this.props.formName, this.props.fieldName, formatted);
        } else if (this.props.currentPhoneNumber === "" && this.state.isLegacyNumber) {
            /**
             * If user erases all field characters for a legacy number, we want to apply mask.
             */
            this.setState({ isLegacyNumber: false });
            this.setMask();
        }
    }

    validatePhoneFormatForReduxForm(value) {
        if (value !== this.emptyMask && value !== this.props.initialPhoneNumber && !this.phoneFormatRegex.test(value) && !this.isNumberValidForOtherFormats(value)) {
            return { messageKey: "members.form.error.phoneNumberError" };
        }
        return undefined;
    }

    validatePhoneFormat(value) {
        if (!value) return undefined;
        return this.phoneFormatRegex.test(value);
    }

    setMask() {
        return this.setState({ fieldMask: "(999) 999-9999" });
    }

    isNumberValidForOtherFormats(rawValue) {
        const digits = rawValue.replace(/\D/g, '');
        if (digits.length !== 10) return false;

        const invalidCharacters = rawValue.replace(/[0-9\s().-]/g, '');
        if (invalidCharacters.length > 0) return false;
        return true;
    }

    onPaste(e) {
        const clipboard = e.clipboardData.getData("Text");

        if (clipboard && !this.isNumberValidForOtherFormats(clipboard)) {
            this.setState({ showFieldValidationError: true });
        }
    }

    onBlur() {
        if (this.state.showFieldValidationError) {
            this.setState({ showFieldValidationError: false });
        }
    }

    render() {
        const { fieldId, fieldName, labelTranslationString, forcedValidationErrorKey, disabled } = this.props;
        const { showFieldValidationError, isLegacyNumber } = this.state;
        return (
            <div>
                <Field
                    id={fieldId}
                    name={fieldName}
                    props={{
                        label: this.context.intl.formatMessage({ id: labelTranslationString }),
                        onPaste: this.onPaste,
                        onBlur: this.onBlur,
                        showFieldValidationError,
                        forcedValidationErrorKey,
                        isLegacyNumber,
                    }}
                    component={MaskedInput}
                    mask={this.state.fieldMask}
                    disabled={disabled}
                    validate={this.validatePhoneFormatForReduxForm}
                />
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    const selector = formValueSelector(ownProps.formName);

    return {
        currentPhoneNumber: selector(state, ownProps.fieldName),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        changeFieldValue: bindActionCreators(changeFieldValue, dispatch),
    };
}
PhoneNumberInput.propTypes = {
    disabled: PropTypes.bool,
    extraProps: PropTypes.object,
    fieldId: PropTypes.string.isRequired,
    fieldName: PropTypes.string.isRequired,
    formName: PropTypes.string.isRequired,
    isLegacy: PropTypes.bool,
    changeFieldValue: PropTypes.func,
    phonePlaceHolder: PropTypes.string,
    labelTranslationString: PropTypes.string.isRequired,
    initialPhoneNumber: PropTypes.string,
    placeholderTranslationString: PropTypes.string,
    currentPhoneNumber: PropTypes.string,
    phonePlaceholder: PropTypes.string,
    forcedValidationErrorKey: PropTypes.string,
};

PhoneNumberInput.contextTypes = {
    intl: intlShape,
};

export default connect(mapStateToProps, mapDispatchToProps)(PhoneNumberInput);



// WEBPACK FOOTER //
// ./src/components/common/form/PhoneNumberInput.js